import createIcon from '../../createIcon';

/**
 * @component @name Tonality
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMSAxOS45M0M3LjA2IDE5LjQ0IDQgMTYuMDggNCAxMkM0IDcuOTIgNy4wNSA0LjU2IDExIDQuMDdWMTkuOTNaTTEzIDQuMDdDMTQuMDMgNC4yIDE1IDQuNTIgMTUuODcgNUgxM1Y0LjA3Wk0xMyA3SDE4LjI0QzE4LjQ5IDcuMzEgMTguNzIgNy42NSAxOC45MiA4SDEzVjdaTTEzIDEwSDE5Ljc0QzE5LjgyIDEwLjMzIDE5Ljg5IDEwLjY2IDE5LjkzIDExSDEzVjEwWk0xMyAxOS45M1YxOUgxNS44N0MxNSAxOS40OCAxNC4wMyAxOS44IDEzIDE5LjkzWk0xOC4yNCAxN0gxM1YxNkgxOC45MkMxOC43MiAxNi4zNSAxOC40OSAxNi42OSAxOC4yNCAxN1pNMTkuNzQgMTRIMTNWMTNIMTkuOTNDMTkuODkgMTMuMzQgMTkuODIgMTMuNjcgMTkuNzQgMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tonality = createIcon('Tonality', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.06 19.44 4 16.08 4 12C4 7.92 7.05 4.56 11 4.07V19.93ZM13 4.07C14.03 4.2 15 4.52 15.87 5H13V4.07ZM13 7H18.24C18.49 7.31 18.72 7.65 18.92 8H13V7ZM13 10H19.74C19.82 10.33 19.89 10.66 19.93 11H13V10ZM13 19.93V19H15.87C15 19.48 14.03 19.8 13 19.93ZM18.24 17H13V16H18.92C18.72 16.35 18.49 16.69 18.24 17ZM19.74 14H13V13H19.93C19.89 13.34 19.82 13.67 19.74 14Z',
      key: '172j0b',
    },
  ],
]);

export default Tonality;
